import { Flex, Tag } from 'antd';
import { useTranslation } from 'react-i18next';
import { spacing } from '../../theming';
import { batchFailureCodeKey, formatProcessingFor } from '../../utils/vinExtraction';
import { monoFontFamily, mutedSmallStyle } from './vinExtractionStyles';
import { useNumberFormat } from './useNumberFormat';
import BatchResultTag from './BatchResultTag';

// The provider's own message can be long: two lines here, the whole text on hover.
const failureMessageStyle = {
    ...mutedSmallStyle,
    fontFamily: monoFontFamily,
    display: '-webkit-box',
    WebkitLineClamp: 2,
    WebkitBoxOrient: 'vertical',
    overflow: 'hidden',
    overflowWrap: 'anywhere',
    maxWidth: 320,
};

/**
 * The result tag, the stuck badge (E21), the failure sub-label (E24: Gemini job vs submission) and, when the API
 * recorded it, why the batch failed and the provider's message (SC-QA-07).
 */
const BatchResultCell = ({ batch }) => {
    const { t } = useTranslation('vinExtraction');
    const { integer } = useNumberFormat();
    const count = integer(batch.carCount);
    const duration = formatProcessingFor(batch.processingFor, {
        hour: t('batches.units.hour'),
        minute: t('batches.units.minute'),
    });

    return (
        <Flex vertical gap={spacing[0.5]} align="flex-start">
            <Flex gap={spacing[0.5]} wrap="wrap">
                <BatchResultTag result={batch.result} />
                {batch.stuck && (
                    <Tag
                        color="warning"
                        bordered={false}
                        icon={<i className="fi fi-rr-triangle-warning" aria-hidden="true" />}
                    >
                        {duration ? t('batches.stuck', { duration }) : t('batches.stuckNoDuration')}
                    </Tag>
                )}
            </Flex>
            {batch.failureKind && (
                <span style={mutedSmallStyle}>{t(`batches.failureKind.${batch.failureKind}`, { count })}</span>
            )}
            {batch.failureCode && (
                <span style={mutedSmallStyle}>
                    {t(`batches.failureCode.${batchFailureCodeKey(batch.failureCode)}`)}
                </span>
            )}
            {batch.failureMessage && (
                <span style={failureMessageStyle} title={batch.failureMessage}>
                    {batch.failureMessage}
                </span>
            )}
        </Flex>
    );
};

export default BatchResultCell;
